import { render, staticRenderFns } from "./Cultivo.vue?vue&type=template&id=00f35c7e&scoped=true"
var script = {}
import style0 from "./Cultivo.vue?vue&type=style&index=0&id=00f35c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f35c7e",
  null
  
)

export default component.exports